import "./ScaffoldingServices.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import ServicesGrid from "./sections/ServicesGrid";
import QuoteAction from "./sections/QuoteAction";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <ServicesGrid />
      <QuoteAction />
      <Footer />
    </div>;
}